import moment from 'moment-timezone'
import { DATE_TIME_ISO_FORMAT } from '../../../utils/dateUtils'

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const transformToUTCValidFormat = (time) => {
  if (time) {
    return moment(time).utc().format(DATE_TIME_ISO_FORMAT)
  }
}

export const getPopupBodyMaxHeight = () => {
  const POPUP_PADDING_TOP = 32
  const POPUP_PADDING_BOTTOM = 24
  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  const popupHeaderHeight = document.querySelector('.calendar-availability-pop-up-header')?.offsetHeight
  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  const popupFooterHeight = document.querySelector('.calendar-availability-pop-up-footer')?.offsetHeight
  return `calc(100vh - ${POPUP_PADDING_TOP + POPUP_PADDING_BOTTOM + popupHeaderHeight + popupFooterHeight}px)`
}
